import { useNearestDesignationsQuery } from "react-migration/domains/constraints/designation/hooks/useNearestDesignationQuery";
import { useSelectionSidebarLoading } from "../../../../Bundle/useSelectionSidebarLoadingState";
import { LayerTypeLayerSummaryProps, SupportedRegions } from "../../../../types";
import { useConnectivityScoreKeyIndicator } from "./useConnectivityScoreKeyIndicator";
import { useLocalServicesDataByGeometry } from "./useLocalServicesDataByGeometry";
import { ConnectivityScoreLearnMore } from "./ConnectivityScoreLearnMore";
import { LocalServicesSection } from "./LocalServicesSection";
import { TRANSPORT_RADIUSES } from "./constants";
import { TransportSection } from "./TransportSection";

type ConnectivityLayerSummaryProps = LayerTypeLayerSummaryProps;

export function ConnectivityLayerSummary({
  selection,
  onLoadingChange,
  print,
}: Readonly<ConnectivityLayerSummaryProps>) {
  const geometry = selection?.feature?.geometry;
  const { distances: transportHubDistances, ...transportHubQuery } = useNearestDesignationsQuery(
    geometry,
    TRANSPORT_RADIUSES
  );

  const { tableData, travelTimesScoreMedian, publicTransportRating, ...localServicesTravelTimeQuery } =
    useLocalServicesDataByGeometry(geometry);

  useSelectionSidebarLoading(onLoadingChange, transportHubQuery.loading ?? localServicesTravelTimeQuery.loading);

  useConnectivityScoreKeyIndicator(transportHubDistances, travelTimesScoreMedian, publicTransportRating);

  if (transportHubQuery.error || localServicesTravelTimeQuery.error) {
    // caught by error boundary
    throw transportHubQuery.error ?? localServicesTravelTimeQuery.error;
  }

  return (
    <>
      <div className="flex flex-col gap-5">
        <TransportSection distances={transportHubDistances} loading={transportHubQuery.loading} />
        <LocalServicesSection tableData={tableData} loading={localServicesTravelTimeQuery.loading} />
      </div>
      {!print && <ConnectivityScoreLearnMore />}
    </>
  );
}

ConnectivityLayerSummary.icon = "icon-lt-circle-line-dot-radius";
ConnectivityLayerSummary.title = "Connectivity score";
ConnectivityLayerSummary.supportedRegions = [SupportedRegions.england];
